module.exports = __webpack_public_path__ + "static/img/product13.e4495f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product13.png
// module id = yekP
// module chunks = 10